module.exports = __webpack_public_path__ + "media/images/web/favicon/apple-icon-57x57-2dfdd207c70ba91dead2a414c0c9c00c.png";